@if ( showOverlay | async ) {
<div class="loading-overlay">
    <div class="loader-box">
        @if (showSpinner) {
            <mat-progress-spinner
                [mode]="spinnerMode"
                [color]="spinnerProps.color"
                [value]="spinnerProps.value"
                [diameter]="spinnerProps.diameter"
                [strokeWidth]="spinnerProps.strokeWidth"
                [style.width.px]="spinnerProps.width"
                [style.height.px]="spinnerProps.height">
            </mat-progress-spinner>
        }
        @if (loadingMsg.length) {
            <div class="err-msg lg text-center">
                {{loadingMsg | translate}}
            </div>
        }
        @if (actionBtns.length) {
            <div class="overlay-actions">
                @for (btn of actionBtns; track $index) {
                    <button class="btn {{btn.className}}" (click)="btn.action()">{{btn.label | translate}}</button>
                }
            </div>
        }
    </div>
</div>

}
